import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { TOP_DOMAINS_DISPLAYED } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/consts";
import { OthersTooltipText } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/DomainsMap.styled";

import { MAX_DOMAINS } from "../../consts";

import { TooltipRow } from "./TooltipRow";

interface IOthersTooltipProps {
    domainsCount: number;
}

export const OthersTooltip: FC<IOthersTooltipProps> = ({ domainsCount }) => {
    return (
        <Box
            minWidth="172px"
            maxWidth="272px"
        >
            <Flex
                flexDirection="column"
                gap="16px"
                width="100%"
            >
                <Text
                    fontVariant="subtitle1"
                    color={colorsPalettes.carbon[500]}
                >
                    {translate("llm.sources_report.source_domains.tooltip.others.title")}
                </Text>
                <Flex
                    flexDirection="column"
                    gap="10px"
                >
                    <TooltipRow
                        name={translate("llm.sources_report.source_domains.tooltip.others.domains-count")}
                        value={domainsCount}
                    />
                </Flex>
                <Flex>
                    <OthersTooltipText
                        fontVariant="input2"
                        color={colorsPalettes.carbon[400]}
                    >
                        {translate("llm.sources_report.source_domains.tooltip.others.description", {
                            count: MAX_DOMAINS - TOP_DOMAINS_DISPLAYED,
                        })}
                    </OthersTooltipText>
                </Flex>
            </Flex>
        </Box>
    );
};
